import React, { useState } from "react";
import { api, formatErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MailCheck, CheckCircle2, XCircle } from "lucide-react";

export const TestEmailCard = ({ defaultTo }) => {
  const [to, setTo] = useState(defaultTo || "");
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);

  const send = async (e) => {
    e.preventDefault();
    setSending(true);
    setResult(null);
    try {
      const { data } = await api.post("/admin/email/test", { to });
      setResult(data);
    } catch (err) {
      setResult({ sent: false, reason: formatErr(err) });
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-testid="test-email-card" className="bg-white border border-slate-200 rounded-md p-5 mt-6">
      <div className="flex items-center gap-2 mb-1">
        <MailCheck className="w-4 h-4 text-slate-500" />
        <div className="text-sm font-semibold tracking-tight">Test email delivery</div>
      </div>
      <p className="text-xs text-slate-500 mb-4">Send a branded test email to any address to check that emails from the app arrive.</p>
      <form onSubmit={send} className="flex flex-wrap items-end gap-3">
        <div className="w-80 max-w-full">
          <Label htmlFor="test-email-to" className="text-xs uppercase tracking-wider text-slate-500">Send to</Label>
          <Input data-testid="test-email-to" id="test-email-to" type="email" required value={to}
                 onChange={(e) => setTo(e.target.value)} className="mt-1 mono" />
        </div>
        <Button data-testid="test-email-send" type="submit" disabled={sending || !to} className="bg-blue-700 hover:bg-blue-800 text-white">
          {sending ? "Sending…" : "Send test email"}
        </Button>
      </form>
      {result && (
        <div data-testid="test-email-result"
             className={`mt-4 text-sm flex items-start gap-2 ${result.sent ? "text-emerald-700" : "text-rose-700"}`}>
          {result.sent ? <CheckCircle2 className="w-4 h-4 mt-0.5" /> : <XCircle className="w-4 h-4 mt-0.5" />}
          <span>
            {result.sent
              ? <>Sent to <span className="mono">{result.to}</span> via <b>{result.sender}</b>. Check the inbox (and spam folder).</>
              : <>Not sent: {result.reason}</>}
          </span>
        </div>
      )}
    </div>
  );
};
